export const pixelsToGigaPixels = (pixels : any) => pixels / 1000000000;

export const gigaPixelsToPixels = (gigaPixels : any) => gigaPixels * 1000000000;